import { computed } from 'vue';
import { useStore } from 'vuex';

export default function useMeta() {
  const store = useStore();
  const meta = computed(() => store.getters.getMeta);

  return meta;
}
